<template>
  <div class="login-container">
    <!-- Logo de EduTrack -->
    <div class="logo-container">
      <img src="/images/EDUTRACK2.png" alt="EduTrack Logo" class="logo" />
    </div>
    
    <!-- Formulario de Login -->
    <form @submit.prevent="login" class="login-form">
      <h2>Iniciar Sesión</h2>
      <div>
        <label for="username">Usuario</label>
        <input v-model="username" id="username" type="text" required />
      </div>
      <div>
        <label for="password">Contraseña</label>
        <input v-model="password" id="password" type="password" required />
      </div>
      <button type="submit">Iniciar Sesión</button>
      <div v-if="error" class="error">{{ error }}</div>
    </form>
  </div>
</template>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'LoginLayout',
  data() {
    return {
      username: '',
      password: '',
      error: ''
    };
  },
  methods: {
    async login() {
      this.error = '';
      try {
        const response = await apiFetch('/login', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            Username: this.username,
            Contrasena: this.password
          })
        });
        if (!response.ok) {
          throw new Error('Usuario o contraseña incorrectos');
        }
  const data = await response.json();
  // Guardar datos importantes en localStorage
  localStorage.setItem('token', data.token);
  localStorage.setItem('userId', data.usuario.Id);
  localStorage.setItem('nombre', data.usuario.Nombre);
  localStorage.setItem('correo', data.usuario.Correo);
  localStorage.setItem('rol', data.usuario.Rol);
  localStorage.setItem('permisos', JSON.stringify(data.permisos));
  if (data.talleres && Array.isArray(data.talleres)) {
    localStorage.setItem('talleres', JSON.stringify(data.talleres));
  }
  this.$emit('login-success');
      } catch (err) {
        this.error = err.message;
      }
    }
  }
};
</script>

<style scoped>
/* Fondo con degradado para toda la página */
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(145deg, rgb(231, 236, 245) 10%, #a8bbd4 100%);
  padding: 2rem;
  margin: 0;
  max-width: none;
}

/* Contenedor del formulario */
.login-container form {
  background: #efc300(255, 255, 255, 0.95);
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 400px;
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #0a2860;
  font-size: 2rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

form > div {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #0a2860;
  font-weight: 600;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
}

input:focus {
  border-color: #efc300;
  box-shadow: 0 0 0 3px rgba(239, 195, 0, 0.2);
  outline: none;
}

button {
  width: 100%;
  padding: 0.875rem;
  background: #0a2860;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(10, 40, 96, 0.3);
}

button:active {
  transform: translateY(0);
}

.error {
  color: #d32f2f;
  margin-top: 1rem;
  text-align: center;
  background: rgba(211, 47, 47, 0.1);
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(211, 47, 47, 0.2);
}

/* Responsive */
@media (max-width: 480px) {
  .login-container {
    padding: 1rem;
    gap: 1rem;
  }
  
  .logo {
    width: 150px;
  }
  
  .login-form {
    padding: 2rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
}
</style>
